import { render, staticRenderFns } from "./unreviewedrequests.vue?vue&type=template&id=152891b0&scoped=true"
import script from "./unreviewedrequests.vue?vue&type=script&lang=js"
export * from "./unreviewedrequests.vue?vue&type=script&lang=js"
import style0 from "./unreviewedrequests.vue?vue&type=style&index=0&id=152891b0&prod&lang=scss&scoped=true"
import style1 from "./unreviewedrequests.vue?vue&type=style&index=1&id=152891b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152891b0",
  null
  
)

export default component.exports